import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

/** Round single-character chip (e.g. a weekday toggle); a touch larger on phones. */
export const CircleChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  borderRadius: '50%',
  width: 36,
  height: 36,
  [theme.breakpoints.up('sm')]: { width: 32, height: 32 },
}));
